import CssBaseline from '@mui/material/CssBaseline'
import GlobalStyles from '@mui/material/GlobalStyles'
import { ThemeProvider } from '@mui/material/styles'
import React from 'react'
import { spotMeTheme } from 'src/constants/createTheme'
import { globalStyles } from 'src/constants/theme'

const inputGlobalStyles = <GlobalStyles styles={globalStyles} />

const drawerGlobalStyles = (
  <GlobalStyles
    styles={{
      '.MuiDrawer-paper': {
        maxHeight: 'calc(100vh - 90px) !important',
        overflow: 'visible'
      }
    }}
  />
)

type IProps = {
  children: React.JSX.Element | React.JSX.Element[]
}

function AllThemeProviders({ children }: IProps) {
  return (
    <ThemeProvider theme={spotMeTheme}>
      <CssBaseline />
      {drawerGlobalStyles}
      {inputGlobalStyles}
      {children}
    </ThemeProvider>
  )
}

export default React.memo(AllThemeProviders)
